import React from 'react';

import styled from 'styled-components';
import BG_INACTIVE_CARD from 'assets/images/bg-forma_debit-inactive.png';
import DISABLED_FORMA_CARD from 'assets/images/img-forma_card-disabled.png';

const PendingCardBackground = styled.div`
  border-radius: 8px;
  background-image: url(${BG_INACTIVE_CARD});
  background-position: center;
  background-size: contain;
  width: 614px;
  height: 401px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
`;

const PendingCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

const PendingCardImg = styled.img`
  width: 360px;
`;

const PendingCardDescription = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  width: 360px;
  text-align: center;
`;

interface Props {
  class_name?: string;
}

const PendingCard = ({ class_name }: Props) => (
  <PendingCardBackground>
    <PendingCardContainer>
      <PendingCardImg
        src={DISABLED_FORMA_CARD}
        alt="Forma Card"
      ></PendingCardImg>
      <PendingCardDescription>
        Your Forma debit card will be mailed to your address. It should arrive
        in the next 5-7 days!
      </PendingCardDescription>
    </PendingCardContainer>
  </PendingCardBackground>
);

export default PendingCard;
